module.exports = __webpack_public_path__ + "img/max-file-content-check.aed28ac9.svg";